var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAccountBalanceWallet(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_30950_153494)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.5 6.56667V4.66667C17.5 3.75 16.75 3 15.8333 3H4.16667C3.24167 3 2.5 3.75 2.5 4.66667V16.3333C2.5 17.25 3.24167 18 4.16667 18H15.8333C16.75 18 17.5 17.25 17.5 16.3333V14.4333C17.9917 14.1417 18.3333 13.6167 18.3333 13V8C18.3333 7.38333 17.9917 6.85833 17.5 6.56667ZM16.6667 8V13H10.8333V8H16.6667ZM4.16667 16.3333V4.66667H15.8333V6.33333H10.8333C9.91667 6.33333 9.16667 7.08333 9.16667 8V13C9.16667 13.9167 9.91667 14.6667 10.8333 14.6667H15.8333V16.3333H4.16667Z",
    fill: "#475467"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.332 11.75C14.0224 11.75 14.582 11.1904 14.582 10.5C14.582 9.80964 14.0224 9.25 13.332 9.25C12.6417 9.25 12.082 9.80964 12.082 10.5C12.082 11.1904 12.6417 11.75 13.332 11.75Z",
    fill: "#475467"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_30950_153494"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccountBalanceWallet);
export default __webpack_public_path__ + "static/media/account_balance_wallet.13271a28e4cb3a1f763646ed32c57085.svg";
export { ForwardRef as ReactComponent };